import React from 'react';

import ContactForm from '../ContactForm';
import Title from './Title';
import Scale from './Scale';
import SurveyAddress from './SurveyAddress';
import SurveyClients from './SurveyClients';

class SurveyPage extends React.Component {

    componentDidMount() {
        document.title = "SURVEYSTUDIO";
    }

    render() {
        return (
            <div>
                <Title/>
                <Scale/>
                <SurveyClients/>
                <SurveyAddress/>
                <ContactForm/>
            </div>
        )
    }
}

export default SurveyPage;


// WEBPACK FOOTER //
// ./src/Components/SurveyStudio/SurveyPage.js